import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as fromModel from '../../services/models';

@Component({
  selector: 'gp-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
  animations: [
    trigger('AnimateSlides1', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(0)' }),
        animate('600ms', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('100ms', style({ opacity: 0, transform: 'translateY(-100%)' })),
      ])
    ])
  ]
})
export class ResultComponent implements OnInit, OnChanges {

  @Input('ComponentType') componentType: fromModel.COMPONENTTYPES;
  constructor() { }

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges) {   
  }



}
